/**
 * Get the tallest child heading block's height
 * Set this height to every child's heading block
 */
export default function ValuesGrid(elements) {
  function setChildHeadingsSameHeight(children, tallestChildHeight) {
    children.forEach((child) => {
      const headingBlock = child.querySelector('.values-block__item-headings');
      const headingBlockHeight = headingBlock.scrollHeight;

      if (headingBlockHeight > tallestChildHeight) {
        tallestChildHeight = headingBlockHeight;
      }
    });

    children.forEach((child) => {
      const headingBlock = child.querySelector('.values-block__item-headings');
      headingBlock.style.height = `${tallestChildHeight}px`;
    });
  }

  function initialChildren(elements) {
    elements.forEach((element) => {
      const children = element.querySelectorAll('.values-block__item');
      const md = 767;
      let tallestChildHeight = 0;

      if (window.matchMedia(`(min-width: ${md}px)`).matches) {
        setChildHeadingsSameHeight(children, tallestChildHeight);
      }
    });
  }

  initialChildren(elements);

  // Reset the height when resizing the window
  window.onresize = () => {
    initialChildren(elements);
  };
}
